import apiService from '../../../../apiService'
import Notification from '../../../../../../../../../resources/js/notification'
const DEFAULT_VALUE = {}

export default {
  namespaced: true,
  state: {
    metrics: {},
    loading: []
  },
  mutations: {
    setMetrics (state, { metrics, statistic }) {
      state.metrics[metrics] = statistic
    },
    setLoading (state, { metrics, loading }) {
      if (loading) {
        state.loading.push(metrics)
      } else {
        state.loading = state.loading.filter(m => m !== metrics)
      }
    }
  },
  actions: {
    fetch ({ commit }, { domain, from, to, type, metrics }) {
      return new Promise(resolve => {
        commit('setLoading', { metrics, loading: true })

        apiService.getTrafficMetrics(domain, from, to, type, metrics)
          .then(response => {
            commit('setMetrics', { metrics, statistic: response.data.statistic })
            commit('setLoading', { metrics, loading: false })

            resolve(response.data)
          })
          .catch(() => {
            commit('setMetrics', { metrics, statistic: DEFAULT_VALUE })
            commit('setLoading', { metrics, loading: false })

            Notification.notifyError({
              title: 'Ошибка',
              content: 'Не удалось загрузить информацию по поисковому трафику.'
            })
          })
      })
    }
  },
  getters: {
    getMetrics: state => metrics => state.metrics[metrics] || {},
    isLoading: state => metrics => state.loading.includes(metrics)
  }
}
